<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="10">
          <b-card-title>
            <b-row align-h="between" align-v="center">
              <b-col>
                <div class="d-flex margin-auto">
                  <b-avatar
                      size="lg"
                      :src="serverUrl + '/' + pathImage"
                      variant="primary"
                      :text="mapSizeText(managerName)">
                  </b-avatar>
                  <div class="ml-3">
                    <span class="text-formatting-v2 h4-v2"> {{ mapperText(managerName) }} </span>
                    <br>
                    <span class="text-formatting-v2 h5-v2" style="color: #78909C">Manager</span>
                  </div>
                </div>
              </b-col>

              <b-col class="ml-3 p-3" style="border: 1px solid #5D5FEF; border-radius: 6px;">
                <div class="d-flex margin-auto justify-content-center">
                  <img
                      class="mr-5"
                      src="@/assets/modules/propinas/icon/location.svg"
                      alt="location"/>
                  <span class="text-formatting-v2 h4-v2"> {{ pointSale }} </span>
                </div>
              </b-col>

              <b-col class="ml-3 p-3" style="border: 1px solid #5D5FEF; border-radius: 6px;">
                <div class="d-flex margin-auto justify-content-center">
                  <img
                      class="mr-5"
                      src="@/assets/modules/propinas/icon/calendar-line.svg"
                      alt="calendar-line"/>
                  <span class="text-formatting-v2 h4-v2"> {{ blockedDate | moment("DD [de] MMMM YYYY") }}</span>

                </div>
              </b-col>

              <b-col cols="1" class="ml-3">
                <div class="pointer">
                  <img
                      v-if="element[index]"
                      v-b-toggle="'accordion-' + index"
                      @click.prevent="element = []"
                      src="@/assets/modules/propinas/icon/arrow-up.svg"
                      alt="arrow-up-worn"/>
                  <img
                      v-else
                      v-b-toggle="'accordion-' + index"
                      @click.prevent="element.push(element[index] = true)"
                      src="@/assets/modules/propinas/icon/arrow-down.svg"
                      alt="arrow-up"/>
                </div>
              </b-col>
            </b-row>
          </b-card-title>

          <b-collapse
              :id="'accordion-'+ index"
              :accordion="'my-accordion' + index"
              role="tabpanel">
            <b-card-text>
              <b-form-textarea
                  id="disable-textarea"
                  style="border-radius: 6px;"
                  class="text-formatting-v2 h5-v2"
                  :value="reasonBlocked"
                  :placeholder="reasonBlocked"
                  rows="6"
                  max-rows="6"
              ></b-form-textarea>
            </b-card-text>
          </b-collapse>

        </b-col>
        <b-col cols="12" md="2" class="margin-auto">
          <b-collapse
              :id="'accordion-'+ index"
              :accordion="'my-accordion' + index"
              role="tabpanel">
            <button
                v-if="isBlocked"
                @click.prevent="forgetBlock({ id: blockId, index })"
                :disabled="getForgetProcessing === true "
                class="button-v2 primary">
              Habiliar
            </button>
            <button
                v-else
                class="button-v2 outline-light">
              <img
                  src="@/assets/modules/propinas/icon/check.svg"
                  alt="check-warning" />
              Habilitado
            </button>
          </b-collapse>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex"
import serverConfig from "@/services/config"

export default {
  name: "ShiftReport",
  props: {
    index: Number,
    managerName: String,
    pointSale: String,
    pathImage: String,
    blockId: Number,
    isBlocked: Boolean,
    reasonBlocked: String,
    blockedDate: String
  },

  data: () => ({
     element: []
  }),

  computed: {
    serverUrl () {
      return serverConfig.permisosURL
    },
    ...mapGetters('modShiftReport', [
      'getForgetProcessing'
    ])
  },

  methods: {
    ...mapActions('modShiftReport', [
      'forgetBlock',
    ]),

  }
}
</script>

<style scoped>

</style>